var toggleDisabled = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		/** Bind toggle disabled aan data-toggle-disabled attribute  */
		if (target.querySelector('[data-toggle-disabled]')) {
			target.querySelector('[data-toggle-disabled]').addEventListener('change', function() {
				if (this.getAttribute('data-toggle-disabled') != '') {
					var target = this.getAttribute('data-toggle-disabled');
					toggleDisabled.toggleDisabled(target);
				}
			});
		}

	},

	/** Toggle disabled function  */
	toggleDisabled: function(t) {
		if (document.querySelector(t)) {
			var target = document.querySelector(t);
			if (target.hasAttribute('disabled')) {
				target.removeAttribute('disabled');
			} else {
				target.setAttribute('disabled', 'true');
			}
		}
	}

};

export default toggleDisabled;
